import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/Components/CustomDay.tsx
import React from 'react';
import './CustomDay.css';
var CustomDay = function (_a) {
    var date = _a.date, events = _a.events, onClick = _a.onClick;
    var eventCount = events.filter(function (event) {
        var eventDate = new Date(event.start).toDateString();
        return eventDate === date.toDateString();
    }).length;
    return (_jsxs("div", { className: 'flex items-center justify-start h-full w-full rounded-full flex-col pt-1', onClick: onClick, children: [_jsx("span", { children: date.getDate() }), eventCount > 0 && (_jsx("div", { className: "event-count", children: eventCount }))] }));
};
export default CustomDay;
